import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Download, Smartphone, Check } from 'lucide-react';
import { usePWAInstall } from '@/hooks/use-pwa-install';

interface PWAInstallButtonProps {
  variant?: 'default' | 'outline' | 'ghost';
  size?: 'default' | 'sm' | 'lg';
  className?: string;
  showIcon?: boolean;
}

export function PWAInstallButton({ 
  variant = 'default', 
  size = 'default',
  className = '',
  showIcon = true 
}: PWAInstallButtonProps) {
  const { canInstall, isInstalled, installPWA } = usePWAInstall();
  const [isInstalling, setIsInstalling] = useState(false);

  const handleInstall = async () => {
    if (!canInstall) return;

    setIsInstalling(true);
    try {
      await installPWA();
    } catch (error) {
      console.error('Installation failed:', error);
    } finally {
      setIsInstalling(false);
    }
  };

  if (isInstalled) {
    return (
      <Button
        variant="outline"
        size={size}
        className={`${className} cursor-default`}
        disabled
      >
        {showIcon && <Check className="h-4 w-4 mr-2" />}
        دابەزێندراوە
      </Button>
    );
  }

  if (!canInstall) {
    return null;
  }

  return (
    <Button
      onClick={handleInstall}
      variant={variant}
      size={size}
      className={className}
      disabled={isInstalling}
    >
      {showIcon && (
        isInstalling ? (
          <div className="h-4 w-4 mr-2 animate-spin rounded-full border-2 border-current border-t-transparent" />
        ) : (
          <Download className="h-4 w-4 mr-2" />
        )
      )}
      {isInstalling ? 'دابەزاندن...' : 'دابەزاندنی ئەپ'}
    </Button>
  );
}